var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Text as RNText } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
export const Heading = (_a) => {
    var { children, size } = _a, props = __rest(_a, ["children", "size"]);
    const styles = useStyleSheet(getStyles);
    return (React.createElement(RNText, Object.assign({}, props, { style: [styles.container, styles[size], props.style] }), children));
};
const getStyles = createStyleSheet(({ color }) => ({
    container: {
        color: color.invert2.p100,
        fontFamily: 'Satoshi',
        letterSpacing: -0.02,
        fontWeight: '900'
    },
    h1: { fontSize: 31, lineHeight: 34 },
    h2: { fontSize: 28, lineHeight: 31 },
    h3: { fontSize: 25, lineHeight: 29 },
    h4: { fontSize: 23, lineHeight: 27 },
    h5: { fontSize: 21, lineHeight: 25 },
    h6: { fontSize: 19, lineHeight: 23 }
}));
//# sourceMappingURL=Heading.js.map